import {
  CreatePlanRequest,
  UpdatePlanRequest,
} from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { post } from '../apiService';
import { invalidatePlansListCache } from './listPlans';

export const updatePlan = async (
  body: CreatePlanRequest | UpdatePlanRequest,
): Promise<{
  data: { status: string; insuranceId: string };
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/insurance/update?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    invalidatePlansListCache();
    loading = false;
    analytics.trackEvent('update', 'plan');
    return {
      data: responseData as { status: string; insuranceId: string },
      loading,
    };
  } catch (error) {
    loading = false;
    throw new Error('Failed to update insurance plan');
  }
};
